import React, { useEffect } from 'react';
import Highcharts from 'highcharts';
import { useAppSelector } from '../../../../../redux/hooks';
interface MyChartProps {
  chartId: string;  // Nuevo prop para identificar cada instancia del gráfico
  plot:any,
  data:any
}
interface DataType {
  type: any, name: any, data:any
  // Aquí puedes agregar más propiedades según la estructura de tus datos
}


const TotalCPU: React.FC<MyChartProps> = ({ chartId,plot ,data}) => {
  const Type = useAppSelector(state => state.CloudSlice.Type)

  let data_poc: DataType[] = [];
  for (const x of data) {
    if (x.name.includes(Type)) {
      data_poc.push(x); // Aquí se añade x al array data_poc
    }
  }
  useEffect(() => {
    // Create the Highcharts chart here
    if (Type==='Global'){
      const options: Highcharts.Options = {
      title: {
        text: 'CPU Usage',
        align: 'left',
      },
      // ... other chart options ...
      subtitle: {
        text: 'CPU currently in use.',
        align: 'left'
    },

    yAxis: {
        title: {
            text: 'Percentage (%)'
        }
    },

    xAxis: {
      type: 'datetime',
      categories:(plot),
      labels: {
          overflow: 'justify'
      }
  },

    legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
    },

    plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
        }
    },

    series: data,

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      },
      credits: {
        enabled: false
    }
    };

    Highcharts.chart(`container-${chartId}`, options)}

    else if(Type!=='Global'){
      const options: Highcharts.Options = {
        title: {
          text: 'CPU Usage',
          align: 'left',
        },
        // ... other chart options ...
        subtitle: {
          text: 'CPU currently in use.',
          align: 'left'
      },
  
      yAxis: {
          title: {
              text: 'Percentage (%)'
          }
      },
  
      xAxis: {
        type: 'datetime',
        categories:(plot),
        labels: {
            overflow: 'justify'
        }
    },
  
      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
      },
  
      plotOptions: {
          series: {
              label: {
                  connectorAllowed: false
              },
          }
      },
  
      series: data_poc,
  
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }]
        },
        credits: {
          enabled: false
      }
      };
  
      Highcharts.chart(`container-${chartId}`, options)
    }
  }, [chartId]); // Empty dependency array to ensure the effect runs only once when the component mounts

  return (
    <div id={`container-${chartId}`}>
      {/* El contenedor div donde se renderizará el gráfico */}
    </div>
  );
};

export default TotalCPU;